import "core-js/modules/es.object.assign.js";
import { h } from "vue";
//@ts-ignore
import { getDefaultSvgPropsValues } from "@vueEntry/SvgIcons/DefaultValues";
export var StreetviewIcon = function StreetviewIcon(props, _ref) {
  var attrs = _ref.attrs;
  var _a, _b, _c, _d, _e, _f, _g;
  props = Object.assign(Object.assign({}, getDefaultSvgPropsValues()), props);
  var _props = props,
    width = _props.width,
    height = _props.height;
  return h("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.018 17.301",
    width: "".concat(width),
    height: "".concat(height),
    "class": (_a = props["class"]) !== null && _a !== void 0 ? _a : "",
    "aria-hidden": (_b = attrs["aria-hidden"]) !== null && _b !== void 0 ? _b : "true"
  }, [h("g", {
    fill: (_c = attrs["fill-color"]) !== null && _c !== void 0 ? _c : "none",
    stroke: (_d = attrs["stroke-color"]) !== null && _d !== void 0 ? _d : "#222",
    "stroke-linecap": "".concat((_e = attrs["stroke-linecap"]) !== null && _e !== void 0 ? _e : "round"),
    "stroke-linejoin": "".concat((_f = attrs["stroke-linejoin"]) !== null && _f !== void 0 ? _f : "round"),
    "stroke-width": "".concat((_g = attrs["stroke-width"]) !== null && _g !== void 0 ? _g : "1.3")
  }, [h("path", {
    d: "M14.469 11.418c2.917.471 4.9 1.391 4.9 2.448 0 1.537-4.191 2.784-9.359 2.784S.65 15.404.65 13.866c0-1.055 1.963-1.97 4.857-2.443"
  }), h("path", {
    d: "M11.86 2.501a1.851 1.851 0 1 0-1.851 1.849 1.851 1.851 0 0 0 1.851-1.849"
  }), h("path", {
    d: "M10.009.65a1.851 1.851 0 1 1-1.851 1.851A1.851 1.851 0 0 1 10.009.65Z"
  }), h("path", {
    // eslint-disable-next-line max-len
    d: "M11.18 13.114a8.14 8.14 0 0 1 .941-2.3 4.594 4.594 0 0 0 .7-2.369V6.978c0-.72-.412-1.127-.921-1.127H8.113a.919.919 0 0 0-.92.92v1.706a4.675 4.675 0 0 0 .612 2.293 11.781 11.781 0 0 1 .98 2.352.93.93 0 0 0 .885.671h.624a.9.9 0 0 0 .886-.679Z"
  })])]);
};